/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * INTAKE is an intake call with the Hiring Manager: its note stays in KnowMe as an intake call proposal of the process and is never sent to eRecruiter. 
 */

export const MeetingTypeDto = {
    CandidateInterview: 'CANDIDATE_INTERVIEW',
    Intake: 'INTAKE',
} as const;

export type MeetingTypeDto = typeof MeetingTypeDto[keyof typeof MeetingTypeDto];



